import React from 'react';
import HeaderPanel from './HeaderPanel';
import BodyPanel from './BodyPanel';

const PCBTesting = () => {
 

  return (
    <div className="flex flex-col h-screen bg-gray-50 mt-20">
      <HeaderPanel />
      <BodyPanel />
    </div>
  );
};

export default PCBTesting;
